import { createFileRoute } from '@tanstack/react-router';
import ActivitiesManagement from '../../components/manager/ActivitiesManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/activities')({
  component: ActivitiesManagementRoute,
});

function ActivitiesManagementRoute() {
  return (
    <ManagerPortal>
      <ActivitiesManagement />
    </ManagerPortal>
  );
}
